/*
 * Assets panel (W2-10 projects-data). Design tokens only; problems are badges with an icon and a word, missing files
 * also get a "Choose file..." button, so nothing relies on colour alone.
 */

.panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--color-surface-1);
  color: var(--color-text);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border-bottom: var(--border-width) solid var(--color-divider);
}

.summary {
  flex: 1;
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}

.body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: var(--space-2) var(--space-2) var(--space-3);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius-sm);
}

.row:hover,
.row:focus-within {
  background: var(--color-surface-hover);
}

.row > svg {
  flex: none;
  margin-top: 2px;
  color: var(--color-text-muted);
}

.row[data-missing] > svg {
  color: var(--color-severity-fatal);
}

.main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.path {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}

.role {
  color: var(--color-text);
}

.usage[data-unused] {
  font-style: italic;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.renameField {
  display: flex;
}

.renameInput {
  flex: 1;
  min-width: 0;
  height: var(--control-h-sm);
  padding: 0 var(--space-2);
  border: var(--border-width) solid var(--color-border-input);
  border-radius: var(--radius-sm);
  background: var(--color-surface-sunken);
  color: var(--color-text);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
}

.renameInput:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.unused {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-top: var(--space-2);
  border-top: var(--border-width) solid var(--color-divider);
}

.unusedHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: 0 var(--space-2);
}

.h3 {
  margin: 0;
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
  color: var(--color-text-muted);
}

.rules {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  margin: 0;
  padding: var(--space-2) var(--space-3);
  border-top: var(--border-width) solid var(--color-divider);
  color: var(--color-text-subtle);
  font-size: var(--text-2xs);
}

.rules > svg {
  flex: none;
  margin-top: 1px;
}
